import {
  AfterContentInit,
  ChangeDetectorRef,
  Component,
  ContentChildren,
  QueryList,
} from '@angular/core';
import { DocTabPanelDirective } from '../doc-tab-panel.directive';

@Component({
  selector: 'app-doc-tabs',
  templateUrl: './doc-tabs.component.html',
  styleUrls: ['./doc-tabs.component.scss'],
})
export class DocTabsComponent implements AfterContentInit {
  @ContentChildren(DocTabPanelDirective)
  panels!: QueryList<DocTabPanelDirective>;

  panelList: DocTabPanelDirective[] = [];

  constructor(private readonly cdr: ChangeDetectorRef) {}

  ngAfterContentInit(): void {
    this.panels.changes.subscribe(() => {
      this.sync();
      this.cdr.markForCheck();
    });
    this.sync();
    this.cdr.markForCheck();
  }

  private sync(): void {
    this.panelList = this.panels?.toArray() ?? [];
  }
}
